module.exports = __webpack_public_path__ + "static/media/intro1.7c135674.mp4";